/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { useLayoutEffect, useRef } from 'preact/hooks';

type Props = {
  width: number;
  height: number;
  draw: (ctx: CanvasRenderingContext2D) => void;
};

export function TimeComponentCanvas2D({ width, height, draw }: Props) {
  const ref = useRef<HTMLCanvasElement>(null);

  useLayoutEffect(() => {
    const canvas = ref.current!;
    const ctx = canvas.getContext('2d')!;

    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    const scale = window.devicePixelRatio;
    canvas.width = Math.floor(width * scale);
    canvas.height = Math.floor(height * scale);
    ctx.scale(scale, scale);
  }, [width, height]);

  useLayoutEffect(() => {
    const canvas = ref.current!;
    const ctx = canvas.getContext('2d')!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    draw(ctx);
  }, [width, height, draw]);

  return <canvas ref={ref}></canvas>;
}
